function a(o = 6) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_";
  let n = "";
  for (let e = 0; e < o; e++) {
    const r = Math.floor(Math.random() * t.length);
    n += t[r];
  }
  return n;
}
export {
  a as s
};
